import { addYears } from '../model/addYears'
import type { IData } from '../model/IData'
import { type IDateFallback } from '../model/IDateFallback'
import type { IPerson } from '../model/IPerson'
import { MAX_AGE } from '../model/MAX_AGE'
import { getAverageAge } from './getAverageAge'
import { getBirthDateFallback } from './getBirthDateFallback'
import { getTodayIsoDate } from './getTodayIsoDate'

const results = new Map<string, IDateFallback>()

export function getDeathDateFallback(
	data: IData,
	person: IPerson,
): Readonly<IDateFallback> {
	// Check cache.
	const lastResult = results.get(person.id)
	if (lastResult) {
		return lastResult
	}
	// Default result.
	let result: IDateFallback = {
		value: person.deathDate,
		isFallback: !person.deathDate,
	}
	// Assume average age after birth, but only if the maximum age has passed
	// since their birth.
	if (result.value == null) {
		const birthDate = getBirthDateFallback(data, person)
		if (birthDate.value) {
			if (addYears(birthDate.value, MAX_AGE) > getTodayIsoDate()) {
				result.value = undefined
				result.isFallback = false
			} else {
				const averageAge = getAverageAge(data, birthDate.value, person.isMale)
				result.value = addYears(birthDate.value, averageAge.average)
				result.fallbackSource = `${birthDate.isFallback ? 'A becsült' : 'A'} születési időponthoz az átlagos életkor (${averageAge.average} év) hozzáadásával.`
			}
		}
	}
	results.set(person.id, result)
	return result
}
